/**
 * @fileoverview CSS module for the ShareModal component in the Storyteller web application.
 * This file contains styles for the share dialog including the modal layout, link display,
 * buttons, and dividers.
 *
 * @example
 * // Basic usage in ShareModal component
 * import css from './ShareModal.module.css'
 *
 * <div className={css.modal}>
 *   <h2 className={css.header}>Share Recording</h2>
 *   <input className={css.link} value={shareUrl} readOnly />
 *   <button className={css.button}>Copy Link</button>
 * </div>
 */


.modal {
    width: 288px;
}

.header {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0 0 1rem;
}

.link {
    background-color: var(--indigo50);
    border: 0;
    border-radius: 0.75rem;
    padding: 1rem;
    margin-bottom: 0.5rem;
    width: 100%;
    box-sizing: border-box;
}

.button {
    width: 100%;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
}

.divider {
    display: flex;
    align-items: center;
    text-align: center;
    background: white;
    margin: 1rem 0;
}

.line {
    flex: 1;
    height: 1px;
    border-top: 1px solid var(--gray200);
}

.or {
    color: var(--neutural500);
    padding: 0 10px;
}
